import { Pipe, PipeTransform } from '@angular/core';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { BuyflowVesselSortType } from 'anchor-shared/lib/model/enum/buyflow-vessel-sort-type';

@Pipe({
  name: 'orderVesselsByField',
})
export class OrderVesselsByBuyflowVesselSortType implements PipeTransform {
  transform(array: any, sortType: BuyflowVesselSortType): Vessel[] {
    if (!Array.isArray(array)) {
      return;
    }
    const sortConfig = getSortConfig(sortType);
    if (sortConfig.order === 'asc') {
      sortAsc(array, sortConfig);
    } else {
      sortDesc(array, sortConfig);
    }
    return array;
  }
}

function sortDesc(array: any, sortConfig: BuyflowSortTypeConfig): void {
  array.sort((a: any, b: any) => {
    if (a[sortConfig.fieldName] > b[sortConfig.fieldName]) {
      return -1;
    } else if (a[sortConfig.fieldName] < b[sortConfig.fieldName]) {
      return 1;
    } else {
      return 0;
    }
  });
}

function sortAsc(array: any, sortConfig: BuyflowSortTypeConfig): void {
  array.sort((a: any, b: any) => {
    if (a[sortConfig.fieldName] < b[sortConfig.fieldName]) {
      return -1;
    } else if (a[sortConfig.fieldName] > b[sortConfig.fieldName]) {
      return 1;
    } else {
      return 0;
    }
  });
}

function getSortConfig(sortType: BuyflowVesselSortType): BuyflowSortTypeConfig {
  switch (sortType) {
    case BuyflowVesselSortType.PRICE_ASC:
      return {
        fieldName: 'halfDayListPrice',
        order: 'asc',
      };
    case BuyflowVesselSortType.PRICE_DESC:
      return {
        fieldName: 'halfDayListPrice',
        order: 'desc',
      };
    case BuyflowVesselSortType.FEATURED_ORDER_ASC:
      return {
        fieldName: 'featuredOrder',
        order: 'asc',
      };
    case BuyflowVesselSortType.FEATURED_ORDER_DESC:
      return {
        fieldName: 'featuredOrder',
        order: 'desc',
      };
    case BuyflowVesselSortType.LENGTH_ASC:
      return {
        fieldName: 'lengthFt',
        order: 'asc',
      };
    default: {
      return {
        fieldName: 'lengthFt',
        order: 'desc',
      };
    }
  }
}

interface BuyflowSortTypeConfig {
  order: 'asc' | 'desc';
  fieldName: string;
}
